import { AutoMap } from "@automapper/classes"
import { PrelevementDTO } from "./prelevement.dto"
import { EModeDesinfection } from "src/app/domain/Dialyse/enum/mode-desinfection"

export class PrelevementGenerateurDialyseDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    bicarbonate?: number
    @AutoMap()
    sodium?: number
    @AutoMap()
    localisation?: number
    @AutoMap()
    autreLocalisation: string = ''
    @AutoMap()
    observations!: string;
    @AutoMap()
    prelevement: PrelevementDTO = new PrelevementDTO()
    @AutoMap()
    modeDesinfection: EModeDesinfection = EModeDesinfection.Flambage;
}